

export const  EvaluacionType={

    ENTREVISTA : 1,
    PERFORMANCE : 2
}
export const EvaluacionTypeLabels={
    [EvaluacionType.ENTREVISTA]: "Entrevista",
    [EvaluacionType.PERFORMANCE]: "Evaluacion Desempeño"
}
